import { render } from "./ClinicianAppLayout.vue?vue&type=template&id=454f41f0&scoped=true"
import script from "./ClinicianAppLayout.vue?vue&type=script&lang=js"
export * from "./ClinicianAppLayout.vue?vue&type=script&lang=js"

import "./ClinicianAppLayout.vue?vue&type=style&index=0&id=454f41f0&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454f41f0"]])

export default __exports__